<template>
  <div class="table-box">
    <global-tag>
      <el-form :model="formData">
        <el-row>
          <el-col :span="4">
            <el-form-item>
              <el-select
                v-model="formData.shengId"
                placeholder="请选择省"
                @change="handleProvince"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item.name"
                  :value="item.adcode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="1">
            <el-select
              v-model="formData.shiId"
              placeholder="请选择市"
              @change="handleCity"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-select
              v-model="formData.quId"
              placeholder="请选择区"
              @change="handleArea"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-select
              v-model="formData.jiedaoId"
              placeholder="请选择街道"
              @change="streetChange"
            >
              <el-option
                v-for="(item, index) in streetList"
                :key="index"
                :label="item.addName"
                :value="item.addCode"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" :offset="1">
            <el-button type="primary" @click="handleClick"
            >新增</el-button
            >
            <el-button type="success" @click="getFindList"
            >搜索</el-button
            >
            <el-button type="info" @click="handleClear"
            >清空</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>

    <!-- tableb表格 -->
    <div class="table_container">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="550px"
        :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
        border
      >
        <el-table-column
          width="80"
          align="center"
          label="序号"
          type="index"
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '序号'
                            ) != -1
                        "
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="社区名称"
          prop="address"
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '社区名称'
                            ) != -1
                        "
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="140px"
          v-if="
                            this.tempTableChekbox.findIndex(
                                (item) => item == '操作'
                            ) != -1
                        "
        >
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="编辑"
              placement="top-start"
            >
              <img
                src="./assets/img/table_edit.png"
                @click="handleTableForm('编辑', scope.row)"
                style="margin-left: 12px; cursor: pointer"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top-start"
            >
              <img
                src="./assets/img/table_delete.png"
                @click="handleDelete(scope.row)"
                style="margin-left: 12px; cursor: pointer"
              />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination_container">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="pageSize"
        :total="total"
        :current-page.sync="pageNo"
        @size-change="handletableDataSize"
        @current-change="handleTableDataChange"
      ></el-pagination>
    </div>
    <el-dialog
      :title="dialogVisibleTitle"
      :visible.sync="dialogVisible"
      width="40%"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div class="dialog_content">
        <div class="demo_input_suffix">
          <p class="label">社区名称：</p>
          <el-input
            placeholder="请输入社区名称"
            v-model.trim="communityName"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="handleSubmit"
                    >确 定</el-button
                    >
                    <el-button @click="dialogVisible = false">取 消</el-button>
                </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    name: "AddressManagement",
    data() {
        return {
            currentCode: "",
            name: "", //社区名称
            communityName: "", //社区名称
            pageSize: 10,
            pageNo: 1,
            total: 0,
            formData: {
                shengId: "",
                shiId: "",
                quId: "",
                jiedaoId: "",
            },
            tempTableChekbox: ["序号", "社区名称", "操作"],
            tableChekbox: ["序号", "社区名称", "操作"],
            tableData: [
                // tabble数据
            ],
            dialogVisible: false, //table表单弹窗
            dialogVisibleTitle: "", //table表单弹窗title
            province: "", //省
            currentStreet: null,
            provinceList: [],
            cityList: [],
            areaList: [],
            streetList: [],
            currentCommunityId: null,
        }
    },
    mounted() {},
    created() {
        this.getProvince()
        this.getFindList()
    },

    methods: {
        handleClear() {
            this.communityName = ""
            this.formData.shengId = ""
            this.formData.shiId = ""
            this.formData.quId = ""
            this.formData.jiedaoId = ""
            this.currentCommunityId = null
            this.currentStreet = null
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.currentCode = ""
            this.getFindList()
        },
        handleClick() {
            if (
                this.formData.jiedaoId === "" ||
                this.formData.jiedaoId === null ||
                this.formData.jiedaoId === undefined
            ) {
                this.$message.info("请选择需要增加的地址")
                return
            }
            this.dialogVisible = true
        },
        search() {
            this.getFindList()
        },
        handleDelete(row) {
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/rbac/admin/address/info/deleteById",
                            method: "POST",
                            data: {
                                id: row.id,
                            },
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message.success("删除成功")
                            } else if (res.code == "10004") {
                                this.$message.error(res.message)
                                this.$router.push("/login")
                            } else {
                                this.$message.error("删除失败")
                            }
                            this.getFindList()
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },
        //获取表格数据
        getFindList() {
            let data = {
                pageSize: this.pageSize,
                pageNo: this.pageNo,
            }
            if (this.currentCode) {
                data.parentId = this.currentCode
            }
            this.$http
                .request({
                    url: "/ypt/admin/standardAddress/info/StandardAddressList",
                    method: "POST",
                    data,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                        }
                        this.tableData = res.content.list || []
                        this.total = res.content.count
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    }
                })
        },
        handleSubmit() {
            if (!this.communityName) {
                this.$message.error("社区名称不能为空")
                return
            }
            let data = {
                addressName: this.communityName,
            }
            if (this.dialogVisibleTitle == "编辑") {
                data.id = this.currentCommunityId.id
            }
            if (this.dialogVisibleTitle == "新增") {
                data.parentId = this.formData.jiedaoId
            }

            this.$http
                .request({
                    url: "/rbac/admin/address/info/insertOrUpdate",
                    method: "POST",
                    data: data,
                })
                .then((res) => {
                    if (res.code == 200) {
                        this.$message.success("保存成功")
                        this.getFindList()
                    } else if (res.code == "10004") {
                        this.$message.error(res.message)
                        this.$router.push("/login")
                    } else {
                        this.$message.error("保存失败")
                    }
                    this.dialogVisible = false
                })
        },
        //清除搜索条件
        handleReset() {
            this.pageSize = 10
            this.pageNo = 1
            this.name = ""
            this.getFindList()
        },
        handleTableForm(title, row) {
            this.dialogVisible = true
            this.dialogVisibleTitle = title
            this.communityName = row.addressName
            this.currentCommunityId = row
        },
        //获取地址
        getDistrict(name = "中国") {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                    subdistrict: 1, //返回下一级行政区
                    extensions: "all",
                    showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                district.search(name, (status, result) => {
                    if (status == "complete") {
                        resolve(result.districtList[0])
                    }
                })
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.formData.shiId = ""
            this.formData.quId = ""
            this.formData.jiedaoId = ""
            this.currentCode = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
        },
        //市级地址发生改变
        async handleCity(val) {
            this.formData.quId = ""
            this.formData.jiedaoId = ""
            this.areaList = []
            this.streetList = []
            this.currentCode = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.formData.jiedaoId = ""
            this.streetList = []
            // val = val.replace(/.$/, "");
            this.currentCode = ""
            let street = await this.getStreetList(val)
            this.streetList = street
        },
        //街道地址发生变化
        streetChange(val) {
            this.currentCode = val
            this.dialogVisibleTitle = "新增"
            let tempArr = [...this.streetList]
            let result = tempArr.find(
                (item, index) => item.adcode + index == val
            )
            this.currentStreet = result
        },
        //街道地址列表
        getStreetList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                    .request({
                        url: "/ypt/admin/addressYpe/info/findList",
                        method: "POST",
                        data: {
                            parentId: val,
                            pageNo: 1,
                            pageSize: -1,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            if (!res.content) {
                                resolve([])
                                return
                            }
                            this.streetList = res.content.list
                            resolve(res.content.list)
                        } else {
                            resolve([])
                        }
                    })
            }).catch((err) => {
                console.log(err)
            })
        },
        //table列checkbox发生变化
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //table表格表单弹窗关闭时事件
        dialogVisibleClone() {
            // this.formData.shengId = ''
            // this.formData.shiId = ''
            // this.formData.quId = ''
            // this.formData.jiedaoId = ''
            // this.currentCommunityId = null
            this.communityName = ""
            // this.currentStreet = null
            // this.cityList = [];
            // this.areaList = [];
            // this.streetList = [];
        },
        //老人信息列表pagesize发生改变
        handletableDataSize(val) {
            this.pageSize = val
            this.getFindList()
        },
        //老人信息列表页码发生改变
        handleTableDataChange(val) {
            this.pageNo = val
            this.getFindList()
        },
    },
}
</script>

<style lang="less" scoped>
.demo_input_suffix {
    display: flex;
    align-items: center;
    padding: 40px 0;
    .label {
        width: 100px;
    }
}
/deep/ .dialog_container {
    .el-dialog__header {
        border-bottom: 1px solid #e5e5e5;
    }
    .el-dialog__body {
        padding-left: 60px;
        padding-right: 60px;
    }
    .dialog_content {
        .el-col {
            text-align: center;
        }
        .el-select {
            .el-input__inner {
                width: 100%;
            }
        }
        .table_add_wraoper {
            .add_table {
                margin-top: 24px;
            }
        }
    }
    .el-dialog__footer {
        background: #f5f5f5;
        padding: 8px 15px;
        border-top: 1px solid #e5e5e5;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
}
.table_container {
    width: 100%;
}
.pagination_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
/deep/ .el_main_container {
    padding: 20px 20px 42px 20px !important;
    background-color: #ffffff !important;
    height: calc(100vh - 60px);
    overflow-y: auto;
    padding: 0;
    background-color: rgba(242, 242, 242, 1);
    &.active {
        padding: 0 !important;
    }
    .table_title {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .btn_group {
            margin-top: 42px;
        }
    }

    // table_add_wraoper
    /deep/ .dialog_container {
        .el-dialog__header {
            border-bottom: 1px solid #e5e5e5;
        }
        .el-dialog__body {
            padding-left: 60px;
            padding-right: 60px;
        }
        .dialog_content {
            .el-col {
                text-align: center;
            }
            .el-select {
                .el-input__inner {
                    width: 100%;
                }
            }
            .table_add_wraoper {
                .add_table {
                    margin-top: 24px;
                }
            }
        }
        .el-dialog__footer {
            background: #f5f5f5;
            padding: 8px 15px;
            border-top: 1px solid #e5e5e5;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
    .table_container {
        margin-top: 12px;
    }
}
</style>
